import React, { FC } from 'react';
import { RouterProvider } from 'react-router-dom';
import { appRouter } from 'app/config/routerConfig';

export const AppRouter: FC = () => {
  return <RouterProvider router={appRouter} />;
};
